import React, { useEffect } from 'react'
import { getAllActiveChildren, getAllChildren, getChildrenGroupedByNursery, getCurrentChild, logout, selectNurserySettingsLoading, updateCurrentChild } from 'src/shared/redux-state/src';
import { useAppSelector, useAppDispatch, store } from 'src/app/services/store';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { ChildrenStoreData, NurseryGroupStoreData } from 'src/shared/types/src';
import CustomButton from '../commonComponents/CustomButton';
import ProfileImageView from '../commonComponents/ProfileImageView';

type iProps = {
    isChildrenListModal: boolean,
    toggleChildrenListModal: () => void
}

const ChildrenListModal: React.FC<iProps> = ({ isChildrenListModal, toggleChildrenListModal }) => {

    const dispatch = useAppDispatch();
    const childrenGroupedByNursery: NurseryGroupStoreData[] = useAppSelector(getChildrenGroupedByNursery);
    const currentChild = useAppSelector(getCurrentChild);
    const settingsLoader: boolean = useAppSelector(selectNurserySettingsLoading);

    const [selectedChild, setSelectedChild] = React.useState<ChildrenStoreData>();

    useEffect(() => {
        if (currentChild && Object.keys(currentChild).length > 0) {
            setSelectedChild(currentChild);
        }
    }, [currentChild]);

    const handleChildSelection = async () => {
        window.history.replaceState({}, '', `${window.location.pathname}`);
        if (selectedChild && (selectedChild.childInstanceKey !== currentChild.childInstanceKey)) {
            await dispatch(updateCurrentChild({ currentChild: selectedChild}));
        }
        toggleChildrenListModal();
    }

    return (
        <Modal 
            isOpen={isChildrenListModal} 
            toggle={toggleChildrenListModal} 
            backdrop={true} 
            scrollable={true}
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader toggle={toggleChildrenListModal}>Select Child</ModalHeader>
            <ModalBody>
                <>
                    {childrenGroupedByNursery?.map((nursery: any) => {
                        const children = nursery.children || [];
                        return (
                            <div className='nursery-child-wrap'>
                                <div className='fs-6 fw-semibold opacity-75'>{nursery.name}</div>
                                <div className='d-flex flex-wrap mx-n-10'>
                                    {children.map((child: any, index: number) => {
                                        return (
                                            <div className='nursery-child-item d-flex align-items-center flex-column pd-x-10 mg-t-20 cursor-pointer' onClick={() => setSelectedChild(child)}>
                                                <ProfileImageView
                                                    name={child?.name}
                                                    imageUrl={child?.photo}
                                                    resizeMode='cover'
                                                    customContainerStyles={`avatar-size-64 ${selectedChild?.childInstanceKey === child.childInstanceKey ? 'border-black' : ''}`}
                                                    checkMark={selectedChild?.childInstanceKey === child.childInstanceKey ? true : false}
                                                />
                                                <div className={`fs-12 mg-t-4 ${selectedChild?.childInstanceKey === child.childInstanceKey ? 'text-black fw-semibold' : 'text-secondary'}`}>{child?.name}</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </>
            </ModalBody>
            <ModalFooter>
                <CustomButton text="Done" color="primary" onClick={handleChildSelection} isLoading={settingsLoader}/>
            </ModalFooter>
        </Modal>
    )
}

export default ChildrenListModal